<template>
  <div>
    <Banner/>
    <!-- <SlideShow/> -->
    <!-- <HomeMain/> -->
    <router-view></router-view>
    <Foot/>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
// import SlideShow from "@/components/SlideShow"
import HomeMain from "@/components/HomeMain"
import Foot from "@/components/Foot"
export default {
  name: 'Home',
  data () {
    return {}
  },
  components:{
    // SlideShow,
    Banner,
    HomeMain,
    Foot
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue